import * as React from 'react';
import { connect } from 'react-redux';
import ProductSearch from './ProductSearch/ProductSearch';
import { Container, Row, Col } from 'reactstrap';
import { useState } from 'react';
import ProductSearchResult from './ProductSearch/ProductSearchResult';
import { ProductInventorySearchFilter } from '../services/ProductInventoryService';

function ProductSearchPage() {

    const [searchFilter, setSearchFilter] = useState<ProductInventorySearchFilter>();    

    return <>
        <div className="bg-white">
            <Container className="py-4">
                <Row>
                    <Col>
                        <ProductSearch onSearchFilterChanged={(sf) => setSearchFilter(sf)} />
                    </Col>
                </Row>
            </Container>
        </div>
        <div className="border-top py-4">
            <Container>
                <Row>
                    <Col>
                        <ProductSearchResult searchFilter={searchFilter} />
                    </Col>
                </Row>
            </Container>
        </div>
    </>
}

export default connect()(ProductSearchPage);
